import ApiClient from "../helpers/ApiClient";

const baseEmpresaEndpoint = (cnpj) => `/empresa/${cnpj}`;

const getEndereco = (cnpj) =>
  ApiClient.apiClientDev.get(`gestao${baseEmpresaEndpoint(cnpj)}/endereco`);

const getTributacaoConfig = (cnpj) =>
  ApiClient.apiClientDef.get(
    `${baseEmpresaEndpoint(cnpj)}/getTributacaoConfig`
  );

const EmpresaApiClient = { getEndereco, getTributacaoConfig };
export default EmpresaApiClient;
